"use strict";
var gpml_utilities_1 = require("./gpml-utilities");
var ANCHOR_DEFAULTS = {
    attributes: {
        Shape: {
            name: 'Shape',
            value: 'None'
        }
    },
    Graphics: {
        attributes: {
            LineThickness: {
                name: 'LineThickness',
                value: 0
            }
        }
    }
};
function applyDefaults(gpmlElement, defaults) {
    var defaultsByShapeType = {
        Circle: {
            attributes: {
                Height: {
                    name: 'Height',
                    value: 8
                },
                LineThickness: {
                    name: 'LineThickness',
                    value: 0
                },
                Shape: {
                    name: 'Shape',
                    value: 'Circle'
                },
                Width: {
                    name: 'Width',
                    value: 8
                }
            }
        },
        None: {
            attributes: {
                Height: {
                    name: 'Height',
                    value: 4
                },
                LineThickness: {
                    name: 'LineThickness',
                    value: 0
                },
                Shape: {
                    name: 'Shape',
                    value: 'None'
                },
                Width: {
                    name: 'Width',
                    value: 4
                }
            }
        }
    };
    var drawAs = !!gpmlElement.attributes.Shape ? gpmlElement.attributes.Shape.value : 'None';
    return gpml_utilities_1.applyDefaults(gpmlElement, [defaultsByShapeType[drawAs], ANCHOR_DEFAULTS, defaults]);
}
exports.applyDefaults = applyDefaults;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYW5jaG9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2FuY2hvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsbURBQXNFO0FBRXRFLElBQU0sZUFBZSxHQUFHO0lBQ3ZCLFVBQVUsRUFBRTtRQUNYLEtBQUssRUFBRTtZQUNOLElBQUksRUFBRSxPQUFPO1lBQ2IsS0FBSyxFQUFFLE1BQU07U0FDYjtLQUNEO0lBQ0QsUUFBUSxFQUFFO1FBQ1QsVUFBVSxFQUFFO1lBQ1gsYUFBYSxFQUFFO2dCQUNkLElBQUksRUFBRSxlQUFlO2dCQUNyQixLQUFLLEVBQUUsQ0FBQzthQUNSO1NBQ0Q7S0FDRDtDQUNELENBQUM7QUFFRix1QkFBOEIsV0FBVyxFQUFFLFFBQVE7SUFDbEQsSUFBSSxtQkFBbUIsR0FBRztRQUN6QixNQUFNLEVBQUU7WUFDUCxVQUFVLEVBQUU7Z0JBQ1gsTUFBTSxFQUFFO29CQUNQLElBQUksRUFBRSxRQUFRO29CQUNkLEtBQUssRUFBRSxDQUFDO2lCQUNSO2dCQUNELGFBQWEsRUFBRTtvQkFDZCxJQUFJLEVBQUUsZUFBZTtvQkFDckIsS0FBSyxFQUFFLENBQUM7aUJBQ1I7Z0JBQ0QsS0FBSyxFQUFFO29CQUNOLElBQUksRUFBRSxPQUFPO29CQUNiLEtBQUssRUFBRSxRQUFRO2lCQUNmO2dCQUNELEtBQUssRUFBRTtvQkFDTixJQUFJLEVBQUUsT0FBTztvQkFDYixLQUFLLEVBQUUsQ0FBQztpQkFDUjthQUNEO1NBQ0Q7UUFDRCxJQUFJLEVBQUU7WUFDTCxVQUFVLEVBQUU7Z0JBQ1gsTUFBTSxFQUFFO29CQUNQLElBQUksRUFBRSxRQUFRO29CQUNkLEtBQUssRUFBRSxDQUFDO2lCQUNSO2dCQUNELGFBQWEsRUFBRTtvQkFDZCxJQUFJLEVBQUUsZUFBZTtvQkFDckIsS0FBSyxFQUFFLENBQUM7aUJBQ1I7Z0JBQ0QsS0FBSyxFQUFFO29CQUNOLElBQUksRUFBRSxPQUFPO29CQUNiLEtBQUssRUFBRSxNQUFNO2lCQUNiO2dCQUNELEtBQUssRUFBRTtvQkFDTixJQUFJLEVBQUUsT0FBTztvQkFDYixLQUFLLEVBQUUsQ0FBQztpQkFDUjthQUNEO1NBQ0Q7S0FDRCxDQUFDO0lBQ0YsSUFBTSxNQUFNLEdBQUcsQ0FBQyxDQUFDLFdBQVcsQ0FBQyxVQUFVLENBQUMsS0FBSyxHQUFHLFdBQVcsQ0FBQyxVQUFVLENBQUMsS0FBSyxDQUFDLEtBQUssR0FBRyxNQUFNLENBQUM7SUFDNUYsTUFBTSxDQUFDLDhCQUFpQixDQUFDLFdBQVcsRUFBRSxDQUFDLG1CQUFtQixDQUFDLE1BQU0sQ0FBQyxFQUFFLGVBQWUsRUFBRSxRQUFRLENBQUMsQ0FBQyxDQUFDO0FBQ2pHLENBQUM7QUE3Q0Qsc0NBNkNDO0FBQUEsQ0FBQyJ9


//////////////////
// WEBPACK FOOTER
// ./~/gpml2pvjson/lib/anchor.js
// module id = 704
// module chunks = 0